import { render, staticRenderFns } from "./BlocLink.vue?vue&type=template&id=a22dd148&lang=pug&"
import script from "./BlocLink.vue?vue&type=script&lang=js&"
export * from "./BlocLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a22dd148')) {
      api.createRecord('a22dd148', component.options)
    } else {
      api.reload('a22dd148', component.options)
    }
    module.hot.accept("./BlocLink.vue?vue&type=template&id=a22dd148&lang=pug&", function () {
      api.rerender('a22dd148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/BlocLink.vue"
export default component.exports